import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { Header } from "../../common/header/Header"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { useParams } from "react-router-dom"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { useStore } from "../../../stores/RootStoreContext"
import { MenuManager } from "../MenuManager"
import { MenuAdmin } from "../../admin/MenuAdmin"
import { ContractorCheckTab } from "./tabs/ContractorCheckTab"
import { PaymentCheckTab } from "./tabs/PaymentCheckTab"
import { IUser } from "../../../types/user/IUser"
import { IMG } from "../../common/CONST"
import { ICurrencyReplenishmentDto } from "@/types/replenishment/ICurrencyReplenishmentDto"

export const CurrencyReplenishmentManager: React.FunctionComponent = () => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const params = useParams()
  const [stage, setStage] = useState<string | undefined>()
  const [replenishment, setReplenishment] = useState<ICurrencyReplenishmentDto>({ stage: "" })
  const [client, setClient] = useState<IUser>()
  const { userStore } = useStore()

  useEffect(() => {
    if (params.id) {
      TrinityAPI.getCurrencyReplenishment(Number(params.id), response => {
        if (response.status === 200) {
          setReplenishment(response.data)
          if (response.data.status === "DONE") {
            setStage("PAYMENT")
          } else if (response.data.stage === "NEW") {
            setStage("CONTRACTOR")
          } else {
            setStage(response.data.stage)
          }
        }
      })
    }
  }, [])

  useEffect(() => {
    if (replenishment.userId) {
      TrinityAPI.getUser(replenishment.userId, response => {
        setClient(response.data)
      })
    }
  }, [replenishment.userId])

  const isPickable = (item: string) => {
    switch (item) {
      case "DOCS":
        return replenishment.status === "SLIP_SENT"
      case "COMPANY":
        return (
          replenishment.status !== "NEW" &&
          replenishment.status !== "DOC_NAC" &&
          replenishment.additionalAgreementBankId
        )
      case "CR":
        return replenishment.status !== "NEW" && replenishment.status !== "DOC_NAC" && replenishment.status !== "DOC"
      case "PAYMENT":
        return replenishment.status === "SLIP_SENT" || replenishment.status === "DONE"
      case "DONE":
        return replenishment.status === "DONE"
    }
  }

  const getItemClazz = (item: string) => {
    if (item === stage) {
      return "deals-stage-item-active"
    } else {
      return !isPickable(item) ? "deals-stage-item-lock" : "deals-stage-item"
    }
  }

  if (!replenishment.id) {
    return null
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      {userStore.isManager ? (
        <MenuManager active={"currency-replenishment"} />
      ) : (
        <MenuAdmin active={"currency-replenishment"} />
      )}
      <section className="deals-info" style={{ display: "block" }}>
        <Header clazzName={"header-main-deals"} />
        <div className="container">
          <h1 className="ui-heading">
            Валютное пополнение {replenishment.id ? `№${replenishment.id}` : ""} на основании запроса №
            {replenishment.clientCurrencyRequestId}
          </h1>
          <ul className="deal-stage-list">
            <li
              className={`deals-stage-item${stage === "CONTRACTOR" ? "-active" : ""}`}
              onClick={() => (replenishment.id ? setStage("CONTRACTOR") : void 0)}
            >
              Данные
            </li>
            <li
              className={getItemClazz("PAYMENT")}
              onClick={() => (isPickable("PAYMENT") ? setStage("PAYMENT") : void 0)}
              style={!isPickable("PAYMENT") ? { pointerEvents: "none" } : {}}
            >
              Проверка оплаты
            </li>
            {/* <li
              className={getItemClazz("DONE")}
              onClick={() => (isPickable("DONE") ? setStage("DONE") : void 0)}
              style={!isPickable("DONE") ? { pointerEvents: "none" } : {}}
            >
              Фиксация
            </li> */}
          </ul>

          <div className="profile-block">
            <img src={IMG.avatar} alt="" className="avatar-img" />
            <div className="profile-block-about">
              <h4 className="profile-name">{client?.name}</h4>
              <p className="main-header-item-text">{client?.username}</p>
              <p className="main-header-item-text">{client?.telegram ? `t.me/${client.telegram}` : ""}</p>
            </div>
          </div>
        </div>

        {stage === "CONTRACTOR" && (
          <ContractorCheckTab
            next={() => setStage("PAYMENT")}
            replenishment={replenishment}
            setReplenishment={setReplenishment}
          />
        )}
        {stage === "PAYMENT" && <PaymentCheckTab replenishment={replenishment} setReplenishment={setReplenishment} />}
      </section>
    </>
  )
}
